<template>
	<div class="d-flex flex-column" style="height: 100%;">
		<common-menu-main />
		<div class="container">
			<slot />
		</div>
		<common-footer-minimum />
	</div>
</template>